// Carry Roll SettingsScreen — Screen 7. Single column, 5 collapsibles (complete).

import { Collapsible } from '../components/calculator/Collapsible';
import { UnitsSwitch } from '../components/settings/UnitsSwitch';
import { ThemeSelector } from '../components/settings/ThemeSelector';
import { OfflineStatus } from '../components/settings/OfflineStatus';
import { FidelitySelector } from '../components/settings/FidelitySelector';
import { ExportPanel } from '../components/settings/ExportPanel';
import { HelpPanel } from '../components/settings/HelpPanel';
import { PracticeMode } from '../components/settings/PracticeMode';
import { AppLockControls } from '../components/settings/AppLockControls';
import { DemoDataControls } from '../components/settings/DemoDataControls';
import { useUI } from '../store/uiStore';

export default function SettingsScreen() {
  const openAbout = useUI((s) => s.openAbout);

  return (
    <div className="measure-content flex flex-col gap-4" data-testid="settings-screen">
      <h2 className="section-title">
        Settings
      </h2>

      <Collapsible title="Preferences" testId="settings-preferences">
        <ThemeSelector />
        <UnitsSwitch />
        <FidelitySelector />
        <OfflineStatus />
      </Collapsible>

      <Collapsible title="App lock" testId="settings-applock" defaultOpen={false}>
        <AppLockControls />
      </Collapsible>

      <Collapsible title="Demo data" testId="settings-demo" defaultOpen={false}>
        <DemoDataControls />
      </Collapsible>

      <Collapsible title="Practice modes" testId="settings-practice" defaultOpen={false}>
        <PracticeMode />
      </Collapsible>

      <Collapsible title="Data & export" testId="settings-data-export" defaultOpen={false}>
        <ExportPanel />
      </Collapsible>

      <Collapsible title="Help" testId="settings-help" defaultOpen={false}>
        <HelpPanel />
      </Collapsible>

      <hr style={{ borderColor: 'var(--color-border)', width: '100%' }} />

      <button type="button" className="btn" onClick={openAbout} data-testid="about-button">
        About
      </button>
    </div>
  );
}
